import {defineStore} from "pinia";

const useAudioStore = defineStore({
    id: "audio",
    state: () => {
        return {
            audio:null,
            song_time:new Date().getTime(),
        }
    },
    actions: {
        getAudio(audio){
            this.audio = audio;
            this.song_time = new Date().getTime();
        },
        clearAudio(){
            this.audio = null;
        }
    },
    getters: {

    },
})

export default useAudioStore
